import React from 'react';
import PropTypes from 'prop-types';
import Card from '@material-ui/core/Card';
import Icon from '@material-ui/core/Icon';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/styles';
import classnames from 'classnames';

const propTypes = {
  classes: PropTypes.shape({}).isRequired,
  noInstances: PropTypes.bool,
  className: PropTypes.string,
  isORv4User: PropTypes.bool.isRequired,
};

const defaultProps = {
  noInstances: false,
  className: null,
};

export function UnstyledORv4Link({ noInstances, classes, className, isORv4User }) {
  const cardClass = noInstances
    ? classnames(classes.noInstanceCard, classes.theCard, className)
    : classnames(classes.instanceCard, classes.theCard, className);
  const textClass = noInstances ? classes.noInstanceText : classes.instanceText;
  const iconClass = noInstances ? classes.noInstanceLinkIcon : classes.instanceLinkIcon;

  if (isORv4User) {
    return (
      <Card
        className={cardClass}
        component="a"
        href={process.env.REACT_APP_ORV4_SSO_LOGIN}
        target="_blank"
        rel="noopener noreferrer"
        elevation={0}
      >
        <div className={textClass}>
          <Typography className={classes.cardText}>
            <span className={classes.question}>
              Looking for existing MongoDB, Redis and Elasticsearch instances?{' '}
            </span>
          </Typography>
          <Typography className={classes.cardText}>
            Log into app.objectrocket.com with SSO.
          </Typography>
        </div>
        <Icon className={iconClass}>open_in_new</Icon>
      </Card>
    );
  }
  return null;
}

UnstyledORv4Link.propTypes = propTypes;
UnstyledORv4Link.defaultProps = defaultProps;

const styles = (theme) => ({
  theCard: {
    backgroundColor: theme.customColors.sky,
    border: `1px solid ${theme.customColors.mediumGrey}`,
    borderRadius: 3,
    color: theme.customColors.darkGrey,
    textDecoration: 'none',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
  },
  instanceCard: {
    display: 'block',
    padding: theme.spacing(2),
  },
  noInstanceCard: {
    display: 'flex',
    padding: theme.spacing(1),
    paddingBottom: theme.spacing(2),
  },
  cardText: {
    fontSize: '1rem',
    '&:not(:last-child)': {
      marginBottom: theme.spacing(1),
    },
  },
  noInstanceText: {
    textAlign: 'left',
  },
  instanceText: {
    textAlign: 'center',
  },
  question: {
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  instanceLinkIcon: {
    fontSize: '2rem',
    position: 'absolute',
    top: '50%',
    right: 10,
    transform: 'translateY(-50%)',
  },
  noInstanceLinkIcon: {
    fontSize: '2rem',
    alignSelf: 'flex-start',
  },
});

export default withStyles(styles)(UnstyledORv4Link);
